import { ofType, combineEpics } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";

import {
  httpGet,
  httpPut,
  httpPost,
  queryString,
  apiStatus,
  errorHandler, httpDelete,
} from "../../../common/httpCall";
import {
  PEOPLE_LIST_MEMBER_NOTES_ATTEMPT,
  peopleListMemberNotesSuccess,
  PEOPLE_ADD_MEMBER_NOTE_ATTEMPT,
  peopleAddMemberNoteSuccess,
  PEOPLE_DELETE_MEMBER_NOTE_ATTEMPT,
  peopleDeleteMemberNoteSuccess,
  PEOPLE_DELETE_MEMBER_NOTE_FAIL,
  PEOPLE_EDIT_MEMBER_NOTE_ATTEMPT,
  peopleEditMemberNoteSuccess,
  PEOPLE_EDIT_MEMBER_NOTE_FAIL,
  PEOPLE_ADD_MEMBER_NOTE_FAIL,
} from "./profile.action";

export const epicGetMemberNotes = (action$, state$) => action$.pipe(
  ofType(PEOPLE_LIST_MEMBER_NOTES_ATTEMPT),
  switchMap(
    ({
      payload: {
        memberId, currentPage, pageSize, enqueueSnackbar,
      },
    }) => httpGet({
      call: `users/${memberId}/notes?${queryString({
        items: pageSize,
        page: currentPage,
      })}`, // NEW_API`,
    }).pipe(
      map((result) => peopleListMemberNotesSuccess(result)),
      catchError((err) => errorHandler(err, enqueueSnackbar)),
    ),
  ),
);

// export const epicAddMemberNote = (action$, state$) => action$.pipe(
//   ofType(PEOPLE_ADD_MEMBER_NOTE_ATTEMPT),
//   switchMap(
//     ({
//       payload: {
//         memberId, note, enqueueSnackbar,
//       },
//     }) => httpPost({
//       call: `users/${memberId}/notes`, // NEW_API`,
//       body: note,
//     }).pipe(
//       map((result) => peopleAddMemberNoteSuccess(result)),
//       catchError((e) => errorHandler(e, enqueueSnackbar, [], () => ({
//         type: PEOPLE_ADD_MEMBER_NOTE_FAIL,
//       }))),
//     ),
//   ),
// );
//
// export const epiEditMemberNote = (action$, state$) => action$.pipe(
//   ofType(PEOPLE_EDIT_MEMBER_NOTE_ATTEMPT),
//   switchMap(
//     ({
//       payload: {
//         memberId, note, enqueueSnackbar,
//       },
//     }) => httpPut({
//       call: `users/${memberId}/notes/${note.id}`, // NEW_API`,
//       body: note,
//     }).pipe(
//       map((result) => {
//         if (result.status === apiStatus.SUCCESS) {
//           enqueueSnackbar("Successfully modified note.", {
//             variant: "success",
//           });
//         }
//         return peopleEditMemberNoteSuccess(result);
//       }),
//       catchError((e) => errorHandler(e, enqueueSnackbar, [], () => ({
//         type: PEOPLE_EDIT_MEMBER_NOTE_FAIL,
//       }))),
//     ),
//   ),
// );
//
export const epicDeleteMemberNote = (action$, state$) => action$.pipe(
  ofType(PEOPLE_DELETE_MEMBER_NOTE_ATTEMPT),
  switchMap(
    ({
      payload: {
        memberId, noteId, enqueueSnackbar,
      },
    }) => httpDelete({
      call: `users/${memberId}/notes/${noteId}`, // NEW_API`,
      body: { is_deleted: true },
    }).pipe(
      map((result) => peopleDeleteMemberNoteSuccess(result)),
      catchError((e) => errorHandler(e, enqueueSnackbar, [], () => ({
        type: PEOPLE_DELETE_MEMBER_NOTE_FAIL,
      }))),
    ),
  ),
);

const peopleProfileEpic = combineEpics(
  epicGetMemberNotes,
  // epicAddMemberNote,
  // epiEditMemberNote,
  epicDeleteMemberNote,
);

export default peopleProfileEpic;
